module.exports = __webpack_public_path__ + "img/hand-flags.3e7a5e25.png";